import { UserIdleTimeOutService } from "./../../services/user-idle-time-out.service";
import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  sMaduleId: any = 1;
  applicantId = localStorage.getItem("IsApplicant");

  constructor(
    private userIdleTimerService: UserIdleTimeOutService,
    private route: Router,
    private commonService: CommonService,
    private toastr: ToastrService,
  ) {
    // let isLog=localStorage.getItem('isLog');
    // if(!isLog){
    //   localStorage.setItem('isLog',"1");
    //   location.reload()
    // }
    // const path = urlParts.slice(-2).join("/");
    // console.log(path);
    // if (path == "components/regForm") {
    // } else if (path != "HOME/dashboard") {
    //   this.commonService.menuPermissions(path);
    // }
    // path != "HOME/dashboard" ? this.commonService.menuPermissions(path) : "";
    // this.commonService.menuPermissions(path);
  }

  async ngOnInit() {
    //    this.userIdleTimerService.autoLogout$.subscribe(() => {
    //   this.Signout(true);
    // });
    const url = window.location.href;
    const urlParts = url.split("/");
    const homeIndex = urlParts.indexOf("OneApp");

    let roleId = localStorage.getItem("RoleId");
    const decrypted: any = await this.commonService.decryptAesGcm(
      roleId,
      this.commonService.key,
    );
    roleId = decrypted;

    // const extractedPath = urlParts
    //   .slice(homeIndex + 1, homeIndex + 3)
    //   .join("/");

    // Extract and sanitize path
    let extractedPath = urlParts.slice(homeIndex + 1, homeIndex + 3).join("/");
    // extractedPath = extractedPath.split("?")[0].toLowerCase();

    // ✅ Special allowlist
    const skipPaths = [
      "paymentSuccess",
      "paymentFailed",
      "components/payment",
      "components/oukRegForm",
      "registration/newRegForm",
      "registration/myAdmission",
      "components/myEnrolment",
      "components/pdsRegForm",
      "misReports/myDocuments",
      "components/myShortCourses",
      "registration/assignMultislectRoles",
      "pg-research/raiseAnAppeal",
      "election-management/raiseElectionAppeal",
    ];

    if (homeIndex !== -1 && homeIndex < urlParts.length - 2) {
      if (skipPaths.some((path) => extractedPath.includes(path))) {
        // ✅ Skip menu permission fetch
      } else if (extractedPath !== "OneApp/dashboard") {
        this.commonService.menuPermissions(extractedPath);
      }
    } else {
      console.log("Path not found in URL");
    }

    // ✅ Skip access checks for allowed paths
    if (!skipPaths.some((path) => extractedPath.includes(path))) {
      if (
        roleId === "3" &&
        this.applicantId == "1" &&
        (extractedPath === "mainDashboard" ||
          extractedPath === "dashboard" ||
          extractedPath == "studentDashboard")
      ) {
        this.toastr.error("Access Denied");
        this.route.navigate(["UnauthorizedComponent"]);
      } else if (
        roleId === "3" &&
        this.applicantId != "1" &&
        (extractedPath === "mainDashboard" ||
          extractedPath === "dashboard" ||
          extractedPath == "applicantDashboard")
      ) {
        this.toastr.error("Access Denied");
        this.route.navigate(["UnauthorizedComponent"]);
      } else if (
        (roleId === "2" || roleId === "2119") &&
        (extractedPath === "mainDashboard" ||
          extractedPath === "studentDashboard" ||
          extractedPath == "applicantDashboard")
      ) {
        this.toastr.error("Access Denied");
      } else if (
        ["1", "2106", "2083", "2084", "2093", "2092"].includes(roleId) &&
        (extractedPath === "dashboard" ||
          extractedPath === "studentDashboard" ||
          extractedPath == "applicantDashboard")
      ) {
        this.toastr.error("Access Denied");
        this.route.navigate(["UnauthorizedComponent"]);
      }
    }
    window.scrollBy(0, 100);
    this.logout();
  }
  changeRole(smID: any) {
    this.sMaduleId = smID;
  }
  // @HostListener("window:click")
  // @HostListener("window:keydown")
  // @HostListener("window:mousemove")
  // refreshUserState() {
  //   clearTimeout(this.userIdleTimerService.userActiveTimer);
  //   this.userIdleTimerService.timeoutUserActivity();
  // }
  logout() {
    this.commonService.activateSpinner();
    let value = localStorage.getItem("UserId");
    let roleId = localStorage.getItem("RoleId");
    let username = !localStorage.getItem("Username");
    if (
      value == "null" ||
      value == "0" ||
      value == "0" ||
      value == "" ||
      roleId == "null" ||
      roleId == "0" ||
      roleId == "0" ||
      roleId == "" ||
      username
    ) {
      this.route.navigate(["/login"]);
      this.commonService.deactivateSpinner();
    }
    this.commonService.deactivateSpinner();
  }
}
